import { render, staticRenderFns } from "./TranslationsWidgetRow.vue?vue&type=template&id=9ed1a194&scoped=true&"
import script from "./TranslationsWidgetRow.vue?vue&type=script&lang=ts&"
export * from "./TranslationsWidgetRow.vue?vue&type=script&lang=ts&"
import style0 from "./TranslationsWidgetRow.vue?vue&type=style&index=0&id=9ed1a194&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed1a194",
  null
  
)

export default component.exports